export const trimDate = (dateString) => {
  return dateString.split("T")[0];
};
export const trimDateTime = (dateString) => {
  const [date, time] = dateString.split("T");
  return `${date} ${time.split(".")[0]}`;
};
